var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"relative z-0 inline-flex NOTshadow-sm rounded-full"},_vm._l((_vm.tabs),function(tab,idx){return _c('button',{key:'tab-' + idx,class:[
			'xfocus:text-orange focus:z-10 focus:outline-none focus:ring-1 focus:ring-orange focus:border-orange',
			idx == 0
				? 'relative inline-flex items-center pl-4 pr-3 py-1.5 rounded-l-full border-2 border-gray-200 font-medium'
				: '',
			idx == _vm.tabs.length - 1
				? '-ml-px relative inline-flex items-center pl-3 pr-4 py-1.5 rounded-r-full border-2 border-gray-200'
				: '',
			idx > 0 && idx < _vm.tabs.length - 1
				? '-ml-px relative inline-flex items-center px-3 py-1.5 border-2'
				: '',
			_vm.isActive(tab)
				? 'border-orange bg-orange font-semibold text-white'
				: 'font-medium text-gray-600 hover:bg-gray-50',
		],attrs:{"aria-current":_vm.isActive(tab) ? 'page' : undefined,"type":"button"},on:{"click":function($event){_vm.activeTab = tab.name}}},[_vm._v("\n\t\t"+_vm._s(tab.name)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }